/**
 * Module dependencies.
 */

import { Ball, Wrapper } from './balls.style';
import { JSX } from 'react';

/**
 * `Props` type.
 */

type Props = {
  current: number;
  onPress: (index: number) => void;
  size: number;
};

/**
 * Export `Balls` component.
 */

export function Balls({ current, onPress, size }: Props): JSX.Element {
  const currentMod = current % size;

  return (
    <Wrapper>
      {Array.from({ length: size }).map((_, index) => (
        <Ball
          isVisible={index === currentMod}
          key={index}
          onClick={() => index !== current && onPress(index)}
        />
      ))}
    </Wrapper>
  );
}
